import { defineStore } from 'pinia';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { ISeoHeadComponent } from '~/types/seoHead';
import type {
  tCoolingOff,
  tLimitBlock,
  tLimitsGeneralData,
  tPagesTitlesResp,
  tPeriodOptions,
  tSessionLimit,
} from '~/types/settings';

export const useStoreResponsibleGamingPage = defineStore('responsibleGamingPage', {
  state: () => ({
    head: {} as ISeoHeadComponent,
    pageTitle: '',
    gamblingLimitsTitle: '',
    selfExclusionTitle: '',
    btnSetNow: '',
    toastLimitUpdateMessage: '',
    toastEmailConfirmMessage: '',
    modalExclusionAgreeText: '',
    exclusionBreakPeriodText: '',
    statusActive: '',
    statusPendingEmailConfirm: '',
    statusPendingDeleteConfirm: '',
    periodOptions: {} as tPeriodOptions,
    coolingOff: {} as tCoolingOff,
    selfExclusion: {} as tCoolingOff,
    limitsGeneralData: {} as tLimitsGeneralData,
    depositLimit: {} as tLimitBlock,
    lossLimit: {} as tLimitBlock,
    wagerLimit: {} as tLimitBlock,
    sessionLimit: {} as tSessionLimit,
    pagesTitles: {} as tPagesTitlesResp,
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadResponsibleGamingData() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'head',
          'periodOptions',
          'coolingOff',
          'coolingOff.modalContent',
          'selfExclusion',
          'selfExclusion.modalContent',
          'limitsGeneralData',
          'depositLimit',
          'lossLimit',
          'wagerLimit',
          'sessionLimit',
          'pagesTitles',
        ]);

        this.requestPromise = strapi()
          .get('responsible-gaming-page', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
